/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ priority: NonNullable<unknown> }} Spaces_Folder_Priority_BadgeInputs */



/**
* | output |
* | --- |
* | "Embedding priority for this folder: {priority}" |
*
* @param {Spaces_Folder_Priority_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_folder_priority_badge = /** @type {((inputs: Spaces_Folder_Priority_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Folder_Priority_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Einbettungspriorität für diesen Ordner: ${i?.priority}`)
	return /** @type {LocalizedString} */ (`Embedding priority for this folder: ${i?.priority}`)
});